import {
  AssetUtil,
  bookmarkAssetMigrations,
  bookmarkAssetProps
} from "@tldraw/editor";
class BookmarkAssetUtil extends AssetUtil {
  static type = "bookmark";
  static props = bookmarkAssetProps;
  static migrations = bookmarkAssetMigrations;
  getDefaultProps() {
    return {
      title: "",
      description: "",
      image: "",
      favicon: "",
      src: null
    };
  }
}
export {
  BookmarkAssetUtil
};
//# sourceMappingURL=BookmarkAssetUtil.mjs.map
